getZipCode().then((zipCode) => {
  if (zipCode) {
    const ffVariantSelector = document.querySelector("variant-radios");
    const ffVariantsIds = ffVariantSelector.dataset.variants.split("-");
    const ffVariantsElements = document.querySelector("#ff-custom-addToCart");
    setTimeout(() => {
      ffVariantsIds.forEach((element, position) => {
        let showFormOnVariant = false;
        const dataSplit = element.split(",");
        fetch("/apps/location-control/products/stocks", {
          method: "POST",
          body: JSON.stringify({
            
              zipCode,
              variantID: dataSplit[0].replace("[", ""),
            
          }),
          headers: {
            "Content-Type": "application/json",
          },
        })
          .then((res) => res.json())
          .then((data) => {
            data = { data };
            const thereIsAnError = !!(data.data.error || data.data.errors);

            const ffRadioSelector = ffVariantSelector.querySelector(
              `input[value=\"${dataSplit[1].replace("]", "")}\"]`
            );
            if ((thereIsAnError && data.data.stock === 0) || thereIsAnError) {
              ffRadioSelector.setAttribute("disabled", true);
              ffRadioSelector.removeAttribute("checked");
            } else if (data.data.stock > 0) {
              showFormOnVariant = true;
            }
            if (showFormOnVariant && !thereIsAnError) {
              ffVariantsElements
                .querySelector(".ff-no-stock")
                .classList.add("hidden");
              ffVariantsElements
                .querySelector("product-form")
                .classList.remove("hidden");
              ffVariantsElements
                .querySelector(".mahou-add-booking")
                .classList.remove("hidden");
              ffVariantsElements
                .querySelector("product-form .ff-submit-button")
                .classList.remove("hidden");
              ffVariantsElements
                .querySelector(".mahou-add-booking")
                .classList.remove("hidden");
            }
          })
          .catch((error) => console.error("Error:", error));
      });
    }, 300);
  }
});
